export enum CACHE_KEYS {
  CLIENTS = 'clients',
  SITE_CAPABILITY = 'siteCapability',
  FREIGHT_TYPE = 'freightType',
}
